import React, { useState, useEffect } from "react";
import "../App.css";
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  Form,
  Alert,
  Spinner,
  InputGroup,
} from "react-bootstrap";
import Footer from "./Footer";
import { Navigate, Link, useLocation } from "react-router-dom"; 
import { useAuth } from "./Home1"; 
import { faUser, faLock, faClockRotateLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Home = () => {
  document.title = "Login - beaconSMS";

  const { login, isLoading, error, isLoggedIn } = useAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  
  // --- 1. Detect Inactivity Reason from URL ---
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const logoutReason = queryParams.get("reason");

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "username") setUsername(value);
    if (name === "password") setPassword(value);
  };

  const trylogin = async (e) => {
    e.preventDefault();
    const success = await login(username, password);
    if (success) console.log("Login successful!");
  };

  if (isLoggedIn) {
    return <Navigate to='/compose' replace />;
  }

  return (
    <div className='bg-primary bg-gradient min-vh-100 d-flex flex-column'>
      <Container className='my-auto'>
        <Row className='justify-content-center align-items-center' style={{ padding: "10px" }}>
          <Col md='5' lg='4'>
            <h4 className='text-center text-white mt-4 mb-3'>beaconSMS</h4>
            
            <Card className='mt-2 shadow-lg border-0 rounded-4'>
              <Card.Body className='p-4'>
                
                {/* --- 2. SESSION EXPIRED ALERT --- */}
                {logoutReason === "inactivity" && !error && (
                  <Alert variant="warning" className="border-0 shadow-sm mb-4 text-center py-3">
                    <FontAwesomeIcon icon={faClockRotateLeft} className="me-2" />
                    <strong>Session Expired</strong>
                    <div className="small opacity-75">You were logged out due to inactivity.</div>
                  </Alert>
                )}

                {/* Error Alert (Standard Login Errors) */}
                <div style={{ minHeight: error ? "60px" : "0px" }} className='d-flex align-items-center justify-content-center mb-2'>
                  {error && (
                    <Alert variant='danger' className='text-center w-100 m-0 py-2 small'>
                      {error}
                    </Alert>
                  )}
                </div>

                <Form className='mt-2' onSubmit={trylogin}>
                  <Form.Group className='mb-3' controlId='home-username-input'>
                    <InputGroup>
                      <InputGroup.Text className="bg-light border-end-0">
                        <FontAwesomeIcon icon={faUser} className='text-primary fa-fw' />
                      </InputGroup.Text>
                      <Form.Control
                        type='text'
                        placeholder='Username'
                        name='username'
                        className="bg-light border-start-0"
                        value={username}
                        onChange={handleInputChange}
                        required
                        disabled={isLoading}
                      />
                    </InputGroup>
                  </Form.Group>

                  <Form.Group className='mb-4' controlId='home-password-input'>
                    <InputGroup>
                      <InputGroup.Text className="bg-light border-end-0">
                        <FontAwesomeIcon icon={faLock} className='text-primary fa-fw' />
                      </InputGroup.Text>
                      <Form.Control
                        type='password'
                        placeholder='Password'
                        className="bg-light border-start-0"
                        name='password'
                        value={password}
                        onChange={handleInputChange}
                        required
                        disabled={isLoading}
                      />
                    </InputGroup>
                  </Form.Group>

                  <div className='d-grid mt-4'>
                    <Button variant='primary' type='submit' className="py-2 fw-bold shadow-sm" disabled={isLoading}>
                      {isLoading ? (
                        <><Spinner size='sm' className='me-2' /> Logging in...</>
                      ) : (
                        "Login"
                      )}
                    </Button>
                  </div>
                </Form>

                <div className='text-center mt-4'>
                  <span className='text-muted small'>Don't have an account? </span>
                  <Link to='/register' className='text-primary text-decoration-none small fw-bold'>
                    Register Here
                  </Link>
                </div>

                <div className='text-center mt-3 border-top pt-3'>
                  <Link to='/home-page' className='text-secondary text-decoration-none small'>
                    « Go Back Home
                  </Link>
                </div>

              </Card.Body>
            </Card>
            <p className="text-center text-white-50 mt-4 small">
              Secure Bulk SMS Gateway
            </p>
          </Col>
        </Row>
      </Container>
      <Footer />
    </div>
  );
};

export default Home;